import { CheetahIconPack } from '@/components/atomic/atoms/CheetahIcon'
import { CategoryId } from '@/features/community/api/document/community-document.types'
import { DocumentCategoryKeys } from '@/features/community/api/document'

export type CommunityCategoryType = (typeof DocumentCategoryKeys)[number]

export const categoryIdByType: { [key in CommunityCategoryType]?: CategoryId } = {
  free_talk: CategoryId.FREE_TALK,
  hospital_question: CategoryId.HOSPITAL_QUESTION,
  plastic_surgery_question: CategoryId.PLASTIC_SURGERY_QUESTION,
  reviews: CategoryId.REVIEWS,
}

export const categoryList: {
  category: CommunityCategoryType
  icon: CheetahIconPack
}[] = [
  {
    category: 'best',
    icon: CheetahIconPack.BEST_CATEGORY,
  },
  {
    category: 'hospital_question',
    icon: CheetahIconPack.HOSPITAL_QUESTION_CATEGORY,
  },
  {
    category: 'plastic_surgery_question',
    icon: CheetahIconPack.PLASTIC_SURGERY_QUESTION_CATEGORY,
  },
  {
    category: 'doctor',
    icon: CheetahIconPack.DOCTOR_CATEGORY,
  },
  {
    category: 'free_talk',
    icon: CheetahIconPack.FREE_TALK_CATEGORY,
  },
  {
    category: 'reviews',
    icon: CheetahIconPack.REVIEWS_CATEGORY,
  },
  {
    category: 'medical_tip',
    icon: CheetahIconPack.MEDICAL_TIP,
  },
]

export const categoryIconById: { [key in CategoryId]: CheetahIconPack } = {
  0: CheetahIconPack.MEDICAL_TIP,
  1: CheetahIconPack.FREE_TALK_CATEGORY,
  2: CheetahIconPack.PLASTIC_SURGERY_QUESTION_CATEGORY,
  3: CheetahIconPack.DOCTOR_CATEGORY,
  5: CheetahIconPack.REVIEWS_CATEGORY,
  11: CheetahIconPack.HOSPITAL_QUESTION_CATEGORY,
  13: CheetahIconPack.ASK_DOCTOR_CATEGORY,
}
